import { CARD_WALL_RADIUS } from "@/shared/ui/cardWall";
import { cn } from "@/shared/lib/utils";

import type { SiteContent, Template } from "../../../api/types";
import { brandFields, getAt } from "../../../model/content";
import type { DraftEditor } from "../../hooks/useDraftEditor";
import { FieldEditor } from "./FieldEditor";

/**
 * 「站点基础」固定组:模板里 `brand.*` 字段,值直接落 `content.brand.*`(键名跟路径末段走,附录 A.9)。
 * 改动与 AI 重写都走编辑器的 `applyAt`(函数式写,重写回来时写在最新那份上)。
 */
export function BrandForm({
  template,
  content,
  editor,
}: {
  template: Template;
  content: SiteContent;
  editor: Pick<DraftEditor, "applyAt" | "rewrite">;
}) {
  const fields = brandFields(template);
  return (
    <section
      aria-label="站点基础"
      className={cn("space-y-3 border border-border bg-card p-4", CARD_WALL_RADIUS)}
    >
      <h2 className="text-sm font-semibold text-foreground">站点基础</h2>
      <div className="grid gap-3 sm:grid-cols-2">
        {fields.map((f) => (
          <FieldEditor
            key={f.path}
            id={`brand-${f.key}`}
            field={f}
            path={f.path}
            value={getAt(content, f.path)}
            binding={content.bindings[f.path]}
            onChange={(v) => editor.applyAt(f.path, v, "user:edit")}
            onRewrite={async (instruction, current) => {
              const v = await editor.rewrite(f.path, instruction, current);
              if (v !== null) editor.applyAt(f.path, v, "ai:rewrite");
              return v !== null;
            }}
          />
        ))}
      </div>
    </section>
  );
}
